/* eslint-disable */
import { combineReducers, } from 'redux';

import fetching from './fetching';

import activeStorePaymentMethod from './activeStorePaymentMethod';
import listStorePaymentMethods from './listStorePaymentMethods';

import activeUserPaymentMethod from './activeUserPaymentMethod';
import listUserPaymentMethods from './listUserPaymentMethods';

import oneclick from './oneclick';
import oneclickStatus from './oneclickStatus';
import oneclickErrorPaymentStatuses from './oneclickErrorPaymentStatuses';


export default combineReducers({
  fetching,

  activeStorePaymentMethod,
  listStorePaymentMethods,

  activeUserPaymentMethod,
  listUserPaymentMethods,

  oneclick,
  oneclickStatus,
  oneclickErrorPaymentStatuses,
});